module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('nav', {
    staticClass: "navbar has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "nav-item"
  }, [_vm._v("\n          social-ui\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "nav-item is-hidden-tablet"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('span', [_vm._v("Login")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-item is-hidden-tablet"
  }, [_c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', [_vm._v("Register")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('span', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('span', [_vm._v("Login")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "button is-primary",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', [_vm._v("Register")])])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "hero is-primary is-medium"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Try it now\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          Unlock awesomeness\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button is-primary is-medium is-inverted",
    attrs: {
      "to": {
        name: 'profile',
        params: {
          profileId: 'me'
        }
      }
    }
  }, [_vm._v("\n          Get started\n        ")])], 1)])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary is-medium"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          Awesome new social site\n        ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n          where people can be social on a site\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline"
  }, [_c('div', {
    staticClass: "column is-one-third has-text-centered"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p'), _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis efficitur nisi non diam convallis laoreet.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third has-text-centered"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p'), _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n              Interdum et malesuada fames ac ante ipsum primis in faucibus. Maecenas vitae finibus risus.\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third has-text-centered"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p'), _c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("\n              Donec euismod lacus ac ipsum placerat pretium ac sed felis. Donec et mauris id augue convallis efficitur in nec purus.\n            ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-light"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "image is-2by1"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third is-offset-1"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n              Aenean neque tellus\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Maecenas ac leo ac dolor suscipit pellentesque.\n              Aenean massa sem, scelerisque vitae odio sed, scelerisque auctor odio.\n              Pellentesque tristique metus ac sollicitudin sagittis.\n              Maecenas ut leo in nisl tincidunt fermentum ut at odio.\n            ")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-primary"
  }, [_vm._v("Get started")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-dark"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-tablet-reversed"
  }, [_c('div', {
    staticClass: "column is-half is-offset-2"
  }, [_c('div', {
    staticClass: "image is-2by1"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x80"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-one-third"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n              Aenean neque tellus\n            ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("\n              Ac sollicitudin sagittis pellentesque tristique metus.\n              Tincidunt fermentum ut at odio maecenas ut leo in nisl.\n              Odio odio aenean sed, scelerisque auctor massa sem, scelerisque vitae.\n              Suscipit ac dolor Maecenas ac leo pellentesque.\n            ")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "button is-primary is-outlined"
  }, [_vm._v("Learn more")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "image is-16by9"
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/160x90"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d94b1e18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 294
// module chunks = 1